import { convertRelativeToAbsolutePercentage } from '@gonfalon/experiments/convertRelativeToAbsolutePercentage';
import type { DraftExperimentTreatmentAllocation } from '@gonfalon/experiments/types';

type RedistributedTreatment = {
  name: string;
  allocationPercent: string;
  baseline: boolean;
  parameters: Array<{ flagKey: string; variationId: string }>;
  imageFileId?: string;
  assignmentVariantId?: string;
};

export const redistributeTreatments = (
  treatmentAllocations: DraftExperimentTreatmentAllocation[] = [],
  controlVariationId: string | undefined,
  experimentAllocation: number | undefined,
  isWarehouseAssignment = false,
): RedistributedTreatment[] => {
  const included = treatmentAllocations.filter(
    (t: DraftExperimentTreatmentAllocation) => t.allocationPercent > 0 || t.included,
  );

  let treatmentIndex = 1;
  return included.map((treatment) => {
    const parameters = isWarehouseAssignment ? [] : (treatment.parameters ?? []);
    const isControl = isWarehouseAssignment
      ? Boolean(treatment.baseline)
      : parameters.some(({ variationId }) => variationId === controlVariationId);
    const treatmentName =
      treatment.name || (isControl ? 'Control' : included.length === 2 ? 'Treatment' : `Treatment ${treatmentIndex}`);

    if (!isControl) {
      treatmentIndex++;
    }

    const assignmentVariantId = isWarehouseAssignment ? treatment.assignmentVariant?.variantId?.trim() : undefined;

    return {
      name: treatmentName,
      allocationPercent: convertRelativeToAbsolutePercentage(
        treatment.allocationPercent,
        experimentAllocation,
      ).toString(),
      baseline: isControl,
      parameters,
      imageFileId: treatment.imageFileId,
      ...(assignmentVariantId ? { assignmentVariantId } : {}),
    };
  });
};
